import { createFileRoute } from "@tanstack/react-router";
import { OuvidoriaPage } from "@/components/pages/OuvidoriaPage";

const SITE = "https://kentro.com.br";

const META = {
  en: {
    title: "Reporting Channel — Kentro Sistemas",
    desc: "Kentro Sistemas reporting channel: send compliments, complaints, suggestions and reports — submissions may be anonymous.",
    ogTitle: "Reporting Channel — Kentro Sistemas",
    ogDesc: "Direct communication between employees, partners and participants of Kentro with the organization's management.",
    locale: "en_US",
    breadcrumbHome: "Home",
    breadcrumbName: "Reporting Channel",
  },
  es: {
    title: "Canal de Denuncias — Kentro Sistemas",
    desc: "Canal de Denuncias de Kentro Sistemas: envía elogios, reclamos, sugerencias y denuncias — el registro puede ser anónimo.",
    ogTitle: "Canal de Denuncias — Kentro Sistemas",
    ogDesc: "Comunicación directa entre colaboradores, socios y participantes de Kentro con la administración.",
    locale: "es_ES",
    breadcrumbHome: "Inicio",
    breadcrumbName: "Canal de Denuncias",
  },
} as const;

export const Route = createFileRoute("/$locale/ouvidoria")({
  head: ({ params }) => {
    const loc: "en" | "es" = params.locale === "es" ? "es" : "en";
    const m = META[loc];
    return {
      meta: [
        { title: m.title },
        { name: "description", content: m.desc },
        { property: "og:title", content: m.ogTitle },
        { property: "og:description", content: m.ogDesc },
        { property: "og:url", content: `${SITE}/${loc}/ouvidoria` },
        { property: "og:locale", content: m.locale },
      ],
      links: [
        { rel: "canonical", href: `${SITE}/${loc}/ouvidoria` },
        { rel: "alternate", hrefLang: "pt-BR", href: `${SITE}/ouvidoria` },
        { rel: "alternate", hrefLang: "en", href: `${SITE}/en/ouvidoria` },
        { rel: "alternate", hrefLang: "es", href: `${SITE}/es/ouvidoria` },
        { rel: "alternate", hrefLang: "x-default", href: `${SITE}/ouvidoria` },
      ],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: m.breadcrumbHome, item: `${SITE}/${loc}/` },
              { "@type": "ListItem", position: 2, name: m.breadcrumbName, item: `${SITE}/${loc}/ouvidoria` },
            ],
          }),
        },
        {
          type: "application/ld+json",
          children: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "@id": `${SITE}/${loc}/ouvidoria`,
            url: `${SITE}/${loc}/ouvidoria`,
            name: m.title,
            description: m.desc,
            inLanguage: loc === "es" ? "es" : "en",
            isPartOf: { "@type": "WebSite", "@id": `${SITE}/#website` },
          }),
        },
      ],
    };
  },
  component: OuvidoriaPage,
});
